import { pickRuntimeConfig, type RuntimeConfig } from '~/common/config/runtimeConfig';

declare global {
  interface Window {
    kpcRuntimeConfig?: RuntimeConfig;
  }
}

/**
 * Overlays the runtime browser settings served by the BFF on the build-time Vite environment.
 *
 * @param buildEnv - Build-time environment (`import.meta.env`).
 * @param runtimeConfig - Settings from `/runtime-config.js`, when present.
 * @returns The build-time environment with every non-empty runtime setting applied on top.
 */
export const mergeRuntimeEnv = (
  buildEnv: ImportMetaEnv,
  runtimeConfig: { [key: string]: unknown } | undefined,
): ImportMetaEnv => ({ ...buildEnv, ...pickRuntimeConfig(runtimeConfig) });

const runtimeEnv = mergeRuntimeEnv(import.meta.env, window.kpcRuntimeConfig);

export default runtimeEnv;
